import script from "./Title.vue?vue&type=script&lang=js&setup=true"
export * from "./Title.vue?vue&type=script&lang=js&setup=true"

const __exports__ = script;

export default __exports__